module.exports = __webpack_public_path__ + "static/media/download.0175aed9.svg";